import { jsx, jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import { Icon } from "@blueprintjs/core";
export default function AdvancedOptions({
  children,
  content,
  label,
  style,
  isOpenByDefault,
  localStorageKey
}) {
  const [isOpen, setOpen] = useState(() => {
    if (localStorageKey) {
      if (window.localStorage.getItem(localStorageKey) === "true") {
        return true;
      } else if (window.localStorage.getItem(localStorageKey) === "false") {
        return false;
      }
    }
    return isOpenByDefault;
  });
  if (!(content || children)) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { style: { marginTop: 5, ...style }, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: () => {
          const newIsOpen = !isOpen;
          setOpen(newIsOpen);
          if (localStorageKey) {
            window.localStorage.setItem(localStorageKey, newIsOpen);
          }
        },
        style: {
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          userSelect: "none"
        },
        className: `tg-toggle-advanced-options`,
        children: [
          /* @__PURE__ */ jsx(
            Icon,
            {
              icon: isOpen ? "caret-down" : "caret-right",
              style: { marginRight: 5 }
            }
          ),
          /* @__PURE__ */ jsx("strong", { children: label || "Advanced" })
        ]
      }
    ),
    isOpen && /* @__PURE__ */ jsx("div", { style: { marginTop: 10 }, children: content || children })
  ] });
}
